export default __webpack_public_path__ + "static/media/IMG_9964.e89483ff.jpeg";